import req from '@/axios/index.js';

const baseURL = process.env.VUE_APP_BASE_API
// const baseURL = 'https://api.admin.lejiandoctor.com/v2'

// 处理加密图片
export function getBaseFile(params) {
  return req('post', 'upload/getBaseFile', params, { baseURL });
}
// 登录
export function getDoctorToken(params) {
  return req('post', 'pharmacist/auth/token', params,  { baseURL });
};
// 获取订单列表
export const getPrescription = function (params) {
  return req('get', 'pharmacist/prescription/list', params,  { baseURL })
}
// 查看病历
export function caseQueryById(params) {
  return req("get", "doctor/case/details", params,  { baseURL });
}
// 获取处方详情
export function getPrescriptionForm(params) {
  return req('get', 'common/prescription/preview', params, { baseURL });
}
// 处方审核
export const prescriptionCheck = function (params) {
  return req('post', 'pharmacist/recipe/check', params,  { baseURL })
};
// 处方复核
export const prescriptionReview = function (params) {
  return req('post', 'pharmacist/recipe/recheck', params,  { baseURL })
};
// 签名
export const prescriptionSign = function (params) {
  return req('post', 'pharmacist/recipe/check/sign?recipeId='+params.recipeId, params,  { baseURL })
}
// 复核签名
export const prescriptionSignReview = function (params) {
  return req('post', 'pharmacist/recipe/recheck/sign?recipeId='+params.recipeId, params,  { baseURL })
}
// 生成报告
export const prescriptionPdf = function (params) {
  return req('post', 'pharmacist/recipe/generate/pdf?recipeId='+params.recipeId, params, { baseURL })
};
// 药师电子签名
export const setSign = function (params) {
  return req('get', 'pharmacist/set/sign', params, { baseURL })
};
// 下载报告
export const downloadPrescriptionPdf = function (params) {
  return req('get', 'pharmacist/recipe/pdf', params, { baseURL})
};
// 药品订单管理接口-药品订单列表
export const pharmacistOrderList = function (params) {
  return req('get', 'pharmacist/order/list', params, { baseURL})
};
// 药品订单管理接口-药品订单列表分类统计
export const pharmacistOrderNum = function (params) {
  return req('get', 'pharmacist/order/classifiedStatistics', params, { baseURL})
};
// 药品订单管理接口-发货新增
export const pharmacistOrderShipping = function (params) {
  return req('post', 'pharmacist/order/shipping', params, { baseURL})
};
// 药品订单管理接口-发货详情
export const pharmacistOrderShippingForm = function (params) {
  return req('get', 'pharmacist/order/shippingForm', params, { baseURL})
};
// 药品管理接口-药品列表
export const drugsList = function (params) {
  return req('post', '/pharmacist/drugs/queryPage', params, { baseURL})
};
// 药品管理接口-设置上架
export const drugsSetMarketable = function (params) {
  return req('post', 'doctor/drugs/setMarketable', params, { baseURL})
};
// 药品管理接口-设置下架
export const setSoldOut = function (params) {
  return req('post', 'doctor/drugs/setSoldOut', params, { baseURL})
};
// 药品管理接口-设置备案
export const uploadDrugCatalogue = function (params) {
  return req('get', '/supervise/baseRegulation/uploadDrugCatalogue', params, { baseURL})
};
// 药品管理接口-所有药品分页列表统计查询
export const listCount = function (params) {
  return req('get', '/pharmacist/drugs/listCount', params, { baseURL})
};

